import "./app/styles/globals.scss";
import Layout from "./shared/Layout";
import { Outlet, useNavigation } from "react-router-dom";
import Loading from "./shared/Loading";

function App() {
  const { state } = useNavigation();

  return (
    <Layout>
      <Outlet />
      {state === "loading" && <Loading />}
    </Layout>
  );
}

export default App;
